import React, { useEffect, useState } from "react";
import DynamicTable from "../../../Components/InputComponents/LookupView";
import { Edit, Delete, Visibility } from "@mui/icons-material";
import { useNavigate, useSearchParams } from "react-router-dom";
import { axiosAPI } from "../../../Components/AxiosComponents/Axios";
import { encryptId } from "../../../Components/CryptoComponent";

function CurrencyList() {
  const navigate = useNavigate();
  const columns = [
    { field: "CL_Id", label: "#" },
    { field: "CL_Code", label: "Currency Code" },
    { field: "CL_Name", label: "Currency" },
    { field: "CL_Symbol", label: "Currency Symbol" },
  ];

  const [searchParams] = useSearchParams();


  const actions = [
    {
      icon: Edit,
      handler: (row) => {
        const encrypted = encodeURIComponent(encryptId(row?.CL_Id));

        navigate(
          `/CurrencyLookup/Edit/${encrypted}?${searchParams.toString()}`
        );
      },
      color: "warning",
    },
  ];

  return (
    <DynamicTable
      columns={columns}
      actions={actions}
      dataAPI={`/Currency/list`}
      title={`Currency`}
      linkvalue={`/CurrencyLookup/Add?${searchParams.toString()}`}
    />
  );
}

export default CurrencyList;
